/**
 * NotificationResponse 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * NotificationResponse
 */
export interface NotificationResponse {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 接收回应的用户ID */
  receiver_id?: string
  /** 发出回应的用户ID */
  respond_user_id?: string
  /** 关联的通知消息ID */
  notification_id?: string
  /** 回应类型：1-同意，2-拒绝，3-忽略，4-其他 */
  respond_type?: number
  /** 回应内容 */
  respond_content?: string
  /** 回应时间 */
  respond_time?: string
}

/**
 * NotificationResponse Schema
 */
export const NotificationResponseSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    receiver_id: {
      description: '接收回应的用户ID',
      format: 'string',
      type: 'string',
      label: '接收回应的用户ID',
    },
    respond_user_id: {
      description: '发出回应的用户ID',
      format: 'string',
      type: 'string',
      label: '发出回应的用户ID',
    },
    notification_id: {
      description: '关联的通知消息ID',
      format: 'string',
      type: 'string',
      label: '关联的通知消息ID',
    },
    respond_type: {
      description: '回应类型：1-同意，2-拒绝，3-忽略，4-其他',
      format: 'int',
      type: 'integer',
      label: '回应类型：1-同意',
    },
    respond_content: {
      description: '回应内容',
      format: 'string',
      type: 'string',
      label: '回应内容',
    },
    respond_time: {
      description: '回应时间',
      format: '*time.Time',
      type: 'string',
      label: '回应时间',
    },
  },
  type: 'object',
}
